import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalPopup } from "../../common";

interface AnalyticsRenameFilterDialogProps {
  isOpen: boolean;
  onOpenChange(open: boolean): void;
  currentName: string;
  onRename(name: string): void;
  isSaving?: boolean;
  nameError?: string | null;
}

function AnalyticsRenameFilterDialog({
  isOpen,
  onOpenChange,
  currentName,
  onRename,
  isSaving = false,
  nameError = null,
}: AnalyticsRenameFilterDialogProps) {
  const { t } = useTranslation();
  const [name, setName] = useState(currentName);

  useEffect(() => {
    if (isOpen) {
      setName(currentName);
    }
  }, [isOpen, currentName]);

  return (
    <ModalPopup
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={t("Analytics.Filters.RenameDialog.Title", "Rename saved filter")}
      width="TINY"
      primaryButtonText={t("Common.Save", "Save")}
      secondaryButtonText={t("Common.Cancel", "Cancel")}
      isLoading={isSaving}
      isPrimaryButtonDisabled={!name.trim() || isSaving}
      onPrimaryButtonClick={() => {
        if (!name.trim()) return;
        onRename(name.trim());
      }}
      onSecondaryButtonClick={() => onOpenChange(false)}
    >
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          {t("Analytics.Filters.SaveDialog.Name", "Name")}
        </label>
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
          value={name}
          maxLength={100}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
        {nameError && (
          <p className="mt-1.5 text-xs text-red-600">{nameError}</p>
        )}
      </div>
    </ModalPopup>
  );
}

export default AnalyticsRenameFilterDialog;
